import PropTypes from 'prop-types';

import classes from './Teachers.module.css';

const Teachers = ({ productData }) => {
  return (
    <div className={classes.section}>
      <aside className={classes.teachersContainer}>
        <p className={classes.title}>Docentes</p>
        {productData.teachers.map(teacher => (
          <div
            key={teacher.name}
            className={classes.teacherContainer}
          >
            <div className={classes.principalDataContainer}>
              <figure className={classes.teacherAvatar}>
                <img src={teacher.image} className={classes.img} />
              </figure>
              <p className={classes.tacherName}>{teacher.name}</p>
            </div>
            <div className={classes.teacherInfoContainer}>
              <p className={classes.tacherDescription}>
                {teacher.description}
              </p>
              <p>Educación y Formación</p>
              {teacher.education ? (
                <ul className={classes.educationList}>
                  {teacher.education.map(item => (
                    <li className={classes.teacherItem} key={item}>
                      {item}
                    </li>
                  ))}
                </ul>
              ) : (
                ''
              )}
            </div>
          </div>
        ))}
      </aside>
    </div>
  );
};

Teachers.propTypes = {
  // eslint-disable-next-line react/require-default-props
  productData: PropTypes.object
};

export default Teachers;
